/**
 * Shared layout for simple legal/content pages (Privacy, Terms).
 *
 * Reuses the Webflow content classes: a `nav-ignore` heading block with the
 * page-load reveals, then a `w-richtext` body inside the standard container,
 * closing with the gold newsletter CTA.
 */
import type { FC, ReactNode } from 'react'

import { GoldCta } from '@/components/products'

interface LegalPageProps {
    title: string
    updated: string
    children: ReactNode
}

export const LegalPage: FC<LegalPageProps> = ({ title, updated, children }) => {
    return (
        <>
            <div className='section'>
                <div className='container nav-ignore'>
                    <div className='animation-on-load-01'>
                        <h2 className='bold-text'>{title}</h2>
                    </div>
                    <div className='animation-on-load-02'>
                        <p className='grey-text'>Last updated: {updated}</p>
                    </div>
                </div>
            </div>

            <div className='section'>
                <div className='divider' />
                <div className='container _6ems'>
                    <div className='fade-in-move-on-scroll'>
                        <div className='w-richtext'>{children}</div>
                    </div>
                </div>
            </div>

            <GoldCta />
        </>
    )
}
